import React from 'react'
import AccountSettingSidebar from '../../../component/common/layout/AccountSettingSidebar'
import SurveyListHeader from '../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../component/common/layout/SurveyListSidebar'
import Svg from '../../../component/common/Svg'
import Card from '../../../core/Card'
import SearchInput from '../../../core/Inputs/SearchInput'
import Switch from '../../../core/Switch'
import style from "../../style.module.css";
import DataTable from 'react-data-table-component';

const columns = [
    {
        name: 'S.No',
        selector: row => row.id,
    },
    {
        name: 'Name',
        selector: row => row.name,
    },

    {
        name: 'Date added',
        selector: row => row.date,
    },

    {
        name: 'Active',
        cell: row => <>
            <div className="switch-wrap">
                < Switch
                    type='def'
                    color='primary'
                    checked={true}
                    disabled={false}
                    fill={false}
                    rtl={false}
                    leftPosition={false}
                    className='SwitchCustom'
                />
            </div>
        </>
    },

    {
        name: 'Action',
        cell: row => <>
            <div className="d-flex action-wrapper">
                <a data-bs-toggle="modal" data-bs-target="#deleteModal" className='action-btn'>
                    <Svg name="table-delete" />
                </a>
            </div>
        </>
    },
];

const data = [
    {
        id: 1,
        name: 'Open Sans',
        date: '22/11/22',


    },
    {
        id: 2,
        name: 'Open Sans',
        date: '22/11/22',
    },
    {
        id: 3,
        name: 'Open Sans',
        date: '22/11/22',
    }
]

export default function Fonts() {
    return (
        <>

            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper bg-white'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex bg-white">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">
                        <AccountSettingSidebar />
                        <div className="flex-grow-1 page-content-wrap">
                            <div className="page-heading d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h1>Manage fonts</h1>
                                </div>
                                <div className="button-wrap">
                                    <button type="button" className="btn btn-primary add-btn" data-bs-toggle="modal" data-bs-target="#addFont" srno="1" value="1">
                                        <Svg name="plus" /> Add new font
                                    </button>
                                </div>
                            </div>
                            <div className="role-wrapper flex-grow-1">
                                <div className="table-wrapper-view">
                                    <div className="search-filter d-flex align-items--center">
                                        <div className="flex-grow-1 search-filter-padding">
                                            <SearchInput
                                                className="custom-search-input"
                                                type='def'
                                                view='outlined'
                                                color='primary'
                                                placeholder='Search'
                                                fill={true}
                                            />
                                        </div>
                                        <div className="drop-wrap d-flex align-items-center">
                                            <label>Sort By - </label>
                                            <div className="dropdown table-dropdown ques-options">
                                                <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Recently added
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="languages">
                                                    <a className="dropdown-item" href="#"> Value 1 </a>
                                                    <a className="dropdown-item" href="#"> Value 2 </a>
                                                    <a className="dropdown-item" href="#"> Value 3 </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table mb-4">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        <input className="form-check-input" type="checkbox" />
                                                    </th>
                                                    <th scope="col">S.No</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Date added</th>
                                                    <th scope="col">Active</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <input className="form-check-input" type="checkbox" />
                                                    </td>
                                                    <td>1</td>
                                                    <td>Open sans</td>
                                                    <td>22/11/22</td>
                                                    <td>
                                                        <div className="switch-wrap">
                                                            < Switch
                                                                type='def'
                                                                color='primary'
                                                                checked={true}
                                                                disabled={false}
                                                                fill={false}
                                                                rtl={false}
                                                                leftPosition={false}
                                                                className='SwitchCustom'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <a href="#" className='action-btn'>
                                                            <Svg name="table-delete" />
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input className="form-check-input" type="checkbox" />
                                                    </td>
                                                    <td>1</td>
                                                    <td>Inter</td>
                                                    <td>22/11/22</td>
                                                    <td>
                                                        <div className="switch-wrap">
                                                            < Switch
                                                                type='def'
                                                                color='primary'
                                                                checked={true}
                                                                disabled={false}
                                                                fill={false}
                                                                rtl={false}
                                                                leftPosition={false}
                                                                className='SwitchCustom'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <a href="#" className='action-btn'>
                                                            <Svg name="table-delete" />
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input className="form-check-input" type="checkbox" />
                                                    </td>
                                                    <td>1</td>
                                                    <td>Poppins</td>
                                                    <td>22/11/22</td>
                                                    <td>
                                                        <div className="switch-wrap">
                                                            < Switch
                                                                type='def'
                                                                color='primary'
                                                                checked={true}
                                                                disabled={false}
                                                                fill={false}
                                                                rtl={false}
                                                                leftPosition={false}
                                                                className='SwitchCustom'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <a href="#" className='action-btn'>
                                                            <Svg name="table-delete" />
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* If Data Table is required */}
                                    {/* <div className='table-wrap custom-data-table fonts-datatable'>
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            selectableRows
                                            pagination
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal fade upload-file-modal" id="addFont" tabIndex={-1} aria-labelledby="addFontLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                        <div className="card-heading">
                                            <h5>Upload fonts</h5>
                                        </div>
                                        <div className="file-upload-box">
                                            <div className="icon-wrap">
                                                <Svg name="font-upload" />
                                            </div>
                                            <div className="button-wrap">
                                                <button type="button" className="btn btn-primary">Upload</button>
                                            </div>
                                            <p>Supported files - <i>- TIFF,OTF,ZIP,</i></p>
                                        </div>
                                    </Card>
                                </div >

                            </div >
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}